import React from 'react';

import { Link, NavLink } from 'react-router-dom';
import { Login, Signup, suspense } from '../dialogs';
import { showDialog, pr, planSpecs } from '../../../ui-components/common';
import { publicConstants } from './public-constants';
import BookDemoBtn from './BookDemoBtn';

import UserBurger from '../../../ui-components/user-burger';

let LinkWrp;

export class HeaderMenuLeft extends React.Component {
  constructor(props) {
    super(props);
    LinkWrp = _props => {
      if (props.page404) return <a href={_props.to} className={_props.className}>{_props.children}</a>
      return (
        <NavLink to={_props.to}
                 className={({ isActive }) => (_props.className || "") + (isActive ? " _active" : "")}
                 onClick={_props.onClick}>{_props.children}
        </NavLink>
      );
    }
    this.mobile = Modernizr.touchevents;
  }

  isApplicationsActive = () => {
    if (this.props.page404) return false;
    if (this.props.page == "smallBusiness" || this.props.page == "gcs-owners" || this.props.page == "gc-self-perform" || this.props.page == "trade-contractors" || this.props.page == "suppliers") {
      return ' _active'
    }
  }
  isResourcesActive = () => {
    if (this.props.page404) return false;
    if (this.props.page == "quick-start"
      || this.props.page == "tutorials"
      || this.props.page == "submittal-templates") {
      return ' _active'
    }
  }
  isPricingActive = () => {
    if (this.props.page404) return false;
    if (this.props.page == "pricing") {
      return ' _active'
    }
  }

  onClick = (e) => {
    if (!this.mobile) return;
    e.persist();
    this.props.setOpenedName && this.props.setOpenedName(e);
  }

  aloneMenuItemClick = (e) => {
    if (window.location.pathname === '/pricing' && window.innerWidth < 1023) this.props.toggleBurger && this.props.toggleBurger();
  }

  render() {
    return (
      <div className='header-menu_left'>
        {this.props.page !== 'turner' &&
          <div className={'__dd' + (this.props.openedName === 'applications' ? ' opened' : '')} onClick={this.onClick} data-name="applications">
            <span className={`__dd-toggl ${this.isApplicationsActive() || ''}`}>Applications<span className="boldHack">Applications</span><div className="arrow"/></span>
            <div className='__dd-body'>
              <LinkWrp to='/gcs-owners'>
                General Contractors<br/>and Owners
              </LinkWrp>
              <LinkWrp to='/gc-self-perform'>
                Self-Perform GCs
              </LinkWrp>
              <LinkWrp to='/trade-contractors'>
                Trade Contractors
              </LinkWrp>
              <LinkWrp to='/suppliers'>
                Suppliers
              </LinkWrp>
              <LinkWrp to='/small-business'>
                Small Businesses
              </LinkWrp>
            </div>
          </div>
        }
        {this.props.page !== 'turner' &&
          <LinkWrp to="/pricing" className='__dd' onClick={this.aloneMenuItemClick}>
            <span className={`__dd-toggl ${this.isPricingActive() || ''}`} style={{pointerEvents: 'auto'}}>
              <span>
                Pricing<span className="boldHack">Pricing</span>
              </span>
            </span>
          </LinkWrp>
        }
        <div className={'__dd' + (this.props.openedName === 'resources' ? ' opened' : '')} onClick={this.onClick} data-name="resources">
          <span className={`__dd-toggl ${this.isResourcesActive() || ''}`}>Resources<span className="boldHack">Resources</span><div className="arrow"/></span>
          <div className='__dd-body'>
            <LinkWrp to="/quick-start">Quick Start Guide</LinkWrp>
            <LinkWrp to="/tutorials">Tutorials and Tips</LinkWrp>
            <LinkWrp to="/submittal-templates">Submittal Templates</LinkWrp>
            <a href="https://blog.submittal.com/" target='_blank'>Blog</a>
          </div>
          <div style={{fontWeight: '500', position: 'absolute', color: 'transparent'}}>.</div> {/*to download 500 font immediately*/}
        </div>
      </div>
    );
  }
}

export default class PublicHeader extends React.Component {
  state = {
    burger: false,
    openedName: null
  }
  headerMenu = React.createRef();

  componentDidMount() {
    window.buildsite.user().open(this.user_change);
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.page !== this.props.page) {
      this.setState({burger: false, openedName: null});
      document.body.classList.remove('overflow_hidden');
    }
  }

  componentWillUnmount() {
    window.buildsite.user().close(this.user_change);
  }

  signUpClick = e => {
    pr(e);
    let plan = this.props.page == 'smallBusiness' ? planSpecs.default_signup_plan : 'total';
    window.modal(suspense(Signup), {plan_id: plan});
  }

  loginClick = showDialog(suspense(Login), {isPublic: true})

  user_change = data => this.setState({ user: data })

  toggleBurger = () => {
    if (!this.state.burger && this.headerMenu.current) this.headerMenu.current.focus();
    document.body.classList.toggle('overflow_hidden');
    this.setState({burger: !this.state.burger, openedName: null});
  }

  scrollIntoPricing = e => {
    pr(e);
    const y = document.getElementById("to_scroll").getBoundingClientRect().top +  window.scrollY - 140;
    window.scroll({
      top: y,
      behavior: 'smooth'
    });
  }

  getStartedLink = () => {
    if (this.props.page == "sign-up") return null;

    let disabled = window.location.search.substring(1) == "success";

    if (this.props.page == "smallBusiness") {
      return <a onClick={this.scrollIntoPricing} disabled={disabled} className='__btn _black'>Get started</a>
    } else return <BookDemoBtn className="_black"/>;

    /*
      let getStartedUrl = _.get(window, 'buildsite.config.calendly_urls.schedule_a_call_url')

      if (this.props.page == "featuresSuppliers" && getStartedUrl) {
      return <a href={getStartedUrl} className='__btn _black'>Get started</a>
    }
    return <NavLink to="/sign-up" className='__btn _black'>Get started</NavLink>*/
  }

  setOpenedName = e => {
    let name = e.currentTarget.dataset.name;
    return this.setState({openedName: this.state.openedName === name ? null : name})
  }

  renderHeaderMenu = () => {
    if (this.props.page === 'login') return null;
    return (
      <>
        <div className="menuBackground"/>
        <nav ref={this.headerMenu} className='header-menu'>
          <HeaderMenuLeft page={this.props.page}  openedName={this.state.openedName} setOpenedName={this.setOpenedName} toggleBurger={this.toggleBurger}/>
          <div className='header-menu_right'>
            { this.state.user
            ? <UserBurger
                user={this.state.user}
                isPublic={true}
                items={
                  this.state.user.status == "live"
                    ? [
                      <a href="/app/dashboard">Dashboard</a>,
                      <a href="/app/settings">Settings</a>
                    ]
                    : this.state.user.status == "ghost"
                      ? [ <a href="/sign-up">Sign-up</a> ]
                      : []
                }
              />
            : <>
                <a href="tel:8887178665" className="_call">Call {publicConstants.phone}</a>
                <a href='#'
                   onClick={this.loginClick}
                   className="_login"
                >Log in<span className="boldHack">Log in</span></a>
                <NavLink to="/contact" className='__btn'>Contact</NavLink>
                {this.getStartedLink()}
              </>
            }
          </div>
        </nav>
      </>
    );
  }

  render = () => (
    <header className={classNames('header', {'greyed_right': this.props.page == 'sign-up' || this.props.page == 'contact'})}>
      <Link to='/home' className='header-logo'/>
      <div className={`header-burger${this.state.burger ? ' _open' : ''}`} onClick={this.toggleBurger}>
        <div/><div/><div/>
      </div>
      { this.renderHeaderMenu() }
    </header>
  )
}
